(function() {
  'use strict';

  angular.module('ringbaPortal.services').factory('hoursScheduleService', hoursScheduleService);

  function hoursScheduleService(
    _
  ) {
    const service = {
      checkDayTime: checkDayTime,
      checkDifferentTime: checkDifferentTime,
      isBasic: isBasic,
      isOpenAfterClosing: isOpenAfterClosing
    };
    return service;

    function checkDayTime(date) {
      if (!date) {
        return true;
      }
      if (date.getHours() < 12 && date.getHours() >= 0) {
        return true;
      } else {
        return false;
      }
    }

    function checkDifferentTime(previousTime, currentTime) {
      if (_isDate(previousTime) && _isDate(currentTime) && previousTime.getHours() !== currentTime.getHours()) {
        return true;
      }
    }

    // Checks to see if all days have the same hours
    function isBasic(hours) {
      let basic = true;
      const compareDay = hours[0];
      _.forEach(hours, function(day) {
        if (!_.isEqual(compareDay, day)) {
          basic = false;
        }
      });
      return basic;
    }

    function _isDate(date) {
      return date instanceof Date;
    }

    /** 
     * Checks if the first value (open time) is after the second value(close time)
    */
    function isOpenAfterClosing(openTime, closeTime) {
      const openDate = new Date(openTime);
      const closeDate = new Date(closeTime);
      const isOpenHourBiggerThanClosingHour = openDate.getHours() > closeDate.getHours();
      const isOpenMinBiggerThanClosingMin = (openDate.getHours() === closeDate.getHours()) &&  openDate.getMinutes() >= closeDate.getMinutes();
      return (isOpenHourBiggerThanClosingHour) || (isOpenMinBiggerThanClosingMin);
    }

  }
})();
